import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { push } from 'react-router-redux';
import { actions } from './Reducer';
import {
  setArtisanPrivateInquiryIsLoading,
  getArtisanPrivateInquirySuccessAction,
  getArtisanPrivateInquiriesSuccessAction,
  deleteArtisanPrivateInquirySuccessAction,
  editArtisanPrivateInquirySuccessAction,
  addArtisanPrivateInquirySuccessAction,
  setPrivateArtisanInquiryAction,
  getArtisanPrivateStagingInquiriesAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../../../notifications/Actions';

function* getArtisanPrivateInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId
  };

  try {
    yield put(setArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getArtisanPrivateInquiry, body);
    const { data } = response;
    const { content, count } = data;
    console.log(data);
    yield put(getArtisanPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPrivateInquiryIsLoading(false));
  }
}

const searchData = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [],
  // filterCustomerID: customerId,
  filterArtisanID: '',
  sort: 'createdAt',
  dir: 'asc'
};

function* getArtisanPrivateInquiries({ payload }) {
  const body = { ...payload, ...searchData };
  try {
    yield put(setArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.getArtisanPrivateInquiries, body);
    const { data } = response;
    const { count, content } = data;
    yield put(getArtisanPrivateInquiriesSuccessAction(content));
    // yield put(getArtisanPrivateStagingInquiriesAction(staging))
    yield put(setPrivateArtisanInquiryAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPrivateInquiryIsLoading(false));
  }
}

function* deleteArtisanPrivateInquiry({ payload }) {
  const {_id} = payload;
  console.log(payload, 'payload');
  try {
    yield put(setArtisanPrivateInquiryIsLoading(true));
    yield call(
      api.deleteArtisanPrivateInquiry,
      payload
    );
    yield put(deleteArtisanPrivateInquirySuccessAction(_id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPrivateInquiryIsLoading(false));
  }
}

function* editArtisanPrivateInquiry({ payload: { id, body } }) {
  try {
    yield put(setArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.editArtisanPrivateInquiry, id, body);
    const { data } = response;
    // yield put(editArtisanPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Inquiry Edited'));
    yield put(push('/customer-private-inquiry-artisan/'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPrivateInquiryIsLoading(false));
  }
}

function* addArtisanPrivateInquiry({ payload }) {
  try {
    yield put(setArtisanPrivateInquiryIsLoading(true));
    const response = yield call(api.addArtisanPrivateinquiry, payload);
    const { data } = response;
    // yield put(addArtisanPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Inquiry Added'));
    yield put(push('/customer-private-inquiry-artisan/'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPrivateInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_ARTISAN_PRIVATE_INQUIREY,
    getArtisanPrivateInquiry
  );
  yield takeLatest(
    actions.GET_ARTISAN_PRIVATE_INQUIRIES,
    getArtisanPrivateInquiries
  );
  yield takeLatest(
    actions.DELETE_PRIVATE_ARTISAN_INQUIRY,
    deleteArtisanPrivateInquiry
  );
  yield takeLatest(
    actions.EDIT_PRIVATE_ARTISAN_INQUIRY,
    editArtisanPrivateInquiry
  );
  yield takeLatest(
    actions.ADD_PRIVATE_ARTISAN_INQUIRY,
    addArtisanPrivateInquiry
  );
}
